<div [class.preicon]="preicon === true" [class.posticon]="posticon === true">
  @if (title) {
    <p>{{title}}</p>
  }
  <ng-content></ng-content>
</div>
